/* Rquiere de mixin.js */

var store = {
    data() {
        return {
            listStores: [],
            listStoreRacks: [],
            listStoreRackModules: [],
            methodsStore: {
                create: 'register',
                createRackModule: 'register',
                get: 'stores',
                getRackModules: 'storeRackModules',
                show: 'store/',
                showRackModule: 'storeRackModule/',
            },
            objectStore: {
                exist: 0,
                id: 0,
                name: '',
                created_at: '',
                updated_at: ''
            },
            objectStoreRackModule: {
                exist: 0,
                id: 0,
                name: '',
                store_id: 0,
                store: {},
                store_rack_id: 0,
                store_rack: {},
                created_at: '',
                updated_at: ''
            },
            paginationStores: [],
            paginationStoreRackModules: [],
            searchStoreRackModules: '',
            searchingStore: false,
            storeIdSelected: 0
        }
    },
    computed: {
    },
    filters: {
    },
    methods: {
        clearObjectStore() {
            this.objectStore.exist = 0
            this.objectStore.id = 0
            this.objectStore.name = ''
            this.objectStore.color = ''
            this.objectStore.created_at = ''
            this.objectStore.updated_at = ''
        },
        clearObjectStoreRackModule() {
            this.objectStoreRackModule.exist = 0
            this.objectStoreRackModule.id = 0
            this.objectStoreRackModule.name = ''
            this.objectStoreRackModule.store_id = 0
            this.objectStoreRackModule.store = {}
            this.objectStoreRackModule.store_rack_id = 0
            this.objectStoreRackModule.store_rack = {}
            this.objectStoreRackModule.created_at = ''
            this.objectStoreRackModule.updated_at = ''
        },
        getAllStores(page = 1) {
            this.searchingStore = true
            this.listStores = []
            let url = this.getApiBackend + this.methodsStore.get
            this.axiosActionIS(url, 'GET', 'getAllStoresResult')
        },
        getAllStoresResult(response) {
            this.searchingStore = false
            if (response.data.success == true) {
                this.listStores = response.data.data
                this.paginationStores = response.data.paginate
            }
            this.getAllStoresResultLocal(response)
        },
        getAllStoresResultLocal(response) {
            console.log('getAllStoresResultLocal no desarrollado', response)
        },
        getAllStoreRackModules(page = 1) {
            let url = this.getApiBackend + this.methodsStore.getRackModules
            this.axiosActionIS(url, 'GET', 'getAllStoreRackModulesResult')
        },
        getAllStoreRackModulesResult(response) {
            if (response.data.success == true) {
                this.listStoreRackModules = response.data.data
                this.paginationStoreRackModules = response.data.paginate
            }
            this.getAllStoreRackModulesResultLocal(response)
        },
        getAllStoreRackModulesResultLocal(response) {
            console.log('getAllStoreRackModulesResultLocal no desarrollado', response)
        },
        saveStore(item) {
            let url = this.getApiBackend + this.methodsStore.show + this.methodsStore.create
            this.axiosActionIS(url, 'POST', 'saveStoreResult', item)
        },
        saveStoreResult(response) {
            this.saveStoreResultLocal(response)
        },
        saveStoreResultLocal(response) {
            console.log('saveStoreResultLocal no desarrollado', response)
        },
        saveStoreRackModule(item) {
            let url = this.getApiBackend + this.methodsStore.showRackModule + this.methodsStore.createRackModule
            this.axiosActionIS(url, 'POST', 'saveStoreRackModuleResult', item)
        },
        saveStoreRackModuleResult(response) {
            this.saveStoreRackModuleResultLocal(response)
        },
        saveStoreRackModuleResultLocal(response) {
            console.log('saveStoreRackModuleResultLocal no desarrollado', response)
        },
        setObjectStore(item) {
            let newItem = Object.create(item)
            for (const property in newItem) {
                this.objectStore[property] = newItem[property]
            }
        },

    },
};

export default store;